import type { Locale } from "@/lib/i18n/config";
import type { LegalPolicyKey } from "@/content/legal-policies";

/** Public contact mailbox — only address shown on marketing surfaces. */
export const PUBLIC_CONTACT_EMAIL = "contact@runwayready.ai" as const;

/** Aligns with RRAIMVP3 LEGAL_VERSION / form consent policyVersion. */
export const LEGAL_VERSION = "2026-08-13" as const;

export const LEGAL_COMPANY = {
  legalName: "Runway Ready AI SL",
  tradeName: "RunwayReady",
  addressLine: "Calle Faraday 7, Parque Científico de Madrid",
  city: "Madrid",
  region: "Comunidad de Madrid",
  postalCode: "28049",
  countryEn: "Spain",
  countryEs: "España",
  cif: "B27598499",
  vat: "ESB27598499",
  email: PUBLIC_CONTACT_EMAIL,
  supportEmail: PUBLIC_CONTACT_EMAIL,
  website: "https://runwayready.ai",
  privacyUrl: "/legal/privacy-policy",
  termsUrl: "/legal/terms-of-service",
  cookieUrl: "/legal/cookie-policy",
  legalNoticeUrl: "/legal/legal-notice",
  aepdUrl: "https://www.aepd.es",
  phone: "+34 711 564 559",
  phoneHref: "tel:+34711564559",
} as const;

export function formatCompanyAddress(locale: Locale): string {
  const c = LEGAL_COMPANY;
  const country = locale === "es" ? c.countryEs : c.countryEn;
  return `${c.addressLine}, ${c.postalCode} ${c.city}, ${c.region}, ${country}`;
}

export type LegalDocLink = {
  href: string;
  /** Snapshot page key for title/content. */
  page: LegalPolicyKey;
  /** Optional legacy title key for Phase-0 dictionary copy. */
  titleKey?: "privacy" | "terms" | "cookies" | "legalNotice";
};

export const LEGAL_DOC_LINKS: LegalDocLink[] = [
  { href: LEGAL_COMPANY.privacyUrl, page: "privacy", titleKey: "privacy" },
  { href: LEGAL_COMPANY.termsUrl, page: "terms", titleKey: "terms" },
  { href: LEGAL_COMPANY.cookieUrl, page: "cookies", titleKey: "cookies" },
  { href: LEGAL_COMPANY.legalNoticeUrl, page: "impressum", titleKey: "legalNotice" },
  { href: "/legal/impressum", page: "impressum" },
  { href: "/legal/accessibility-statement", page: "accessibility" },
  { href: "/legal/return-policy", page: "return_policy" },
  { href: "/legal/shipping-policy", page: "shipping_policy" },
  { href: "/legal/eula", page: "eula" },
  { href: "/legal/disclaimer", page: "disclaimer" },
  { href: "/legal/acceptable-use-policy", page: "acceptable_use" },
  { href: "/legal/dpa", page: "dpa" },
  { href: "/legal/service-level-agreement", page: "sla" },
];
